const illustrationTab = [
    {
        list: ['Animated Explainers', 'Stock Footage Videos', 'Whiteboard Tutorials', ' Presentations & GIFs', 'Video Infographics', 'Branded Characters', 'Sreen & Webcam Recording']
    },
    {
        list: ['Brand Management', 'Team & Role Management', 'Collaborative Editing', ' Comments & Approvals', 'Team Folders', ' Enterprise-Grade Security']
    },
    {
        list: ['Download as MP4, PPTX, PDF, JPG', 'Internal Company Content Hub', 'Social Media Publishing', 'Slack and Microsoft® Teams', 'Sharing', 'LMS Integration']
    }
]

const cards = [
    {
        name: 'Create',
        list: ['Animated Explainers', 'Stock Footage Videos', 'Whiteboard Tutorials', ' Presentations & GIFs', 'Video Infographics', 'Branded Characters', 'Sreen & Webcam Recording']
    },
    {
        name: 'Manage',
        list: ['Brand Management', 'Team & Role Management', 'Collaborative Editing', ' Comments & Approvals', 'Team Folders', ' Enterprise-Grade Security']
    },
    {
        name: 'Distribute',
        list: ['Download as MP4, PPTX, PDF, JPG', 'Internal Company Content Hub', 'Social Media Publishing', 'Slack and Microsoft® Teams', 'Sharing', 'LMS Integration']
    }
]

const employee = [
    {
        name: 'Learning & development',
        photo: 'https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1615537998/hp2021/employees/L_D_Image_gqp2dv.png',
        img: {
            img0: 'https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1615560935/hp2021/employee_icons/LD/L_D_shape3.svg',
            img1: 'https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1615560935/hp2021/employee_icons/LD/L_D_bubble.svg',
            img2: 'https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1615560935/hp2021/employee_icons/LD/L_D_laptop.svg',
            img3: 'https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1615560935/hp2021/employee_icons/LD/L_D_shape.svg',
            img4: 'https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1615560935/hp2021/employee_icons/LD/L_D_shape2.svg',
        },
        content: "Transform text-heavy training materials into bite-sized videos and e-learning content.",
        link: "https://www.powtoon.com/solution/learning-development"
    },
    {
        name: 'Internal Comms',
        photo: 'https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1615538001/hp2021/employees/Internal_Coms_awu32o.png',
        img: {
            img0: 'https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1615560887/hp2021/employee_icons/Internal_Comms/iternalcomms_icon_face1.svg',
            img1: 'https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1615560887/hp2021/employee_icons/Internal_Comms/iternalcomms_icon_cloud.svg',
            img3: 'https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1615560886/hp2021/employee_icons/Internal_Comms/iternalcomms_icon_face.svg',
            img4: 'https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1615560886/hp2021/employee_icons/Internal_Comms/iternalcomms_icon_cloud-1.svg'
        },
        content: "Make engaging videos for internal company announcements, events, and kickoffs. ",
        link: "https://www.powtoon.com/training-home/"
    },
    {
        name: 'HR',
        photo: 'https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1615537998/hp2021/employees/HR_aia7j2.png',
        img: {
            img0: 'https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1615560857/hp2021/employee_icons/HR/hr_icon_magnify.svg',
            img1: 'https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1615560856/hp2021/employee_icons/HR/hr_icon_icon.svg',
            img2: 'https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1615560855/hp2021/employee_icons/HR/hr_icon_burger.svg'
        },
        content: "Empower employees with visual content for recruitment, onboarding, and events.",
        link: "https://www.powtoon.com/lp/remote-world/"
    },
    {
        name: 'Sales',
        photo: 'https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1615537999/hp2021/employees/Sales_cafyns.png',
        img: {
            img0: 'https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1615560863/hp2021/employee_icons/Sales/sales_icon_coin.svg',
            img1: 'https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1615560863/hp2021/employee_icons/Sales/sales_icon_mask.svg',
            img3: 'https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1615560853/hp2021/employee_icons/Sales/sales_icon_wallet.svg',
            img4: 'https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1615560853/hp2021/employee_icons/Sales/sales_icon_coin1.svg'
        },
        content: "Make sales videos that are quick to personalize and simple to share with prospects. ",
        link: "https://www.powtoon.com/video-templates/sales-make-video"
    },
    {
        name: 'Consulting',
        photo: 'https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1615537998/hp2021/employees/Consulting_frq6xd.png',
        img: {
            img0: 'https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1615561441/hp2021/employee_icons/Consulting/consulting_icon_cloud.svg',
            img1: 'https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1615561441/hp2021/employee_icons/Consulting/consulting_icon_dots.svg',
            img2: 'https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1615561441/hp2021/employee_icons/Consulting/consulting_icon_bulb.svg'
        },
        content: "Turn complex presentations into professional videos that engage and win new clients. ",
        link: "https://www.powtoon.com/solution/consulting"
    },
    {
        name: 'IT',
        photo: 'https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1615537998/hp2021/employees/IT_zrul0z.png',
        img: {
            img0: 'https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1615560861/hp2021/employee_icons/IT/it_icon_key.svg',
            img1: 'https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1615560860/hp2021/employee_icons/IT/it_icon_setting.svg',
            img2: 'https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1615560860/hp2021/employee_icons/IT/it_icon_setting1.svg',
        },
        content: "Easily make IT videos and visual content for support, training, and software rollouts.",
        link: "https://www.powtoon.com/lp/remote-world/"
    },
    {
        name: 'Marketing',
        photo: 'https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1615537999/hp2021/employees/Marketing_vfmdix.png',
        img: {
            img0: 'https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1615560863/hp2021/employee_icons/Marketing/marketing_icon_like.svg',
            img1: 'https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1615560863/hp2021/employee_icons/Marketing/marketing_icon_sharp.svg',
            img3: 'https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1615560861/hp2021/employee_icons/Marketing/marketing_icon_mark.svg',
            img4: 'https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1615560861/hp2021/employee_icons/Marketing/marketing_icon_megaphone.svg'
        },
        content: "Capture your audience with video ads, product demos, and branded social content.",
        link: "https://www.powtoon.com/video-templates/marketing-strategy-make-video"
    },
    {
        name: 'Education',
        photo: 'https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1615537998/hp2021/employees/EDU_xrb3zp.png',
        img: {
            img0: 'https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1615560855/hp2021/employee_icons/Education/education_icon_imac.svg',
            img1: 'https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1615560855/hp2021/employee_icons/Education/education_icon_book.svg'
        },
        content: "Keep students motivated with fresh animated explainers and quick lesson recordings.",
        link: "https://www.powtoon.com/edu-home/"
    },
]

const slider = [
    {
        name: 'Jennifer Baker',
        position: 'Senior Manager, Retail Learning & Development',
        img: 'https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1615543883/hp2021/slider_1/slider-logo.png',
        content: "“Foot Locker, Inc.’s retail team now receives vibrant and fully branded micro-learning videos that capture our organization’s spirit and celebration of sneaker and youth culture around the globe.”"
    },
    {
        name: 'Miranda Ormsby',
        position: 'Systems Integration Business Analyst',
        img: 'https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1615543883/hp2021/slider_1/slider-logo-2.png',
        content: "“My team helps with change management in our organization and we love using Powtoons to demonstrate plans, products, and even IT demonstrations. It’s the perfect way to avoid ‘Death by PowerPoint’ and keep our viewers engaged.”"
    },
    {
        name: 'Janire Fernández Esteban',
        position: 'People Solutions',
        img: 'https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1615543883/hp2021/slider_1/slider-logo-3.svg',
        content: "“Powtoon is being really useful for us! It helps us improve internal communication. Dynamic videos bring us closer to employees and help us engage them. In addition, training on the platform is really easy thanks to the webinars offered by the team. Without a doubt, a great tool that we will continue using in the company!!”"
    },
    {
        name: 'Katie Tulod',
        position: 'Senior Provider Collaboration Manager',
        img: 'https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1615543883/hp2021/slider_1/slider-logo-4.svg',
        content: "“Our team loves using Powtoon to create dynamic videos about complex healthcare metrics and programs that are easy to digest for our external stakeholders. We have seen an increase in program engagement and have reduced the need for spending hours holding webinars.”"
    },
    {
        name: 'Jennifer Baker',
        position: 'Senior Manager, Retail Learning & Development',
        img: 'https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1615543883/hp2021/slider_1/slider-logo.png',
        content: "“Foot Locker, Inc.’s retail team now receives vibrant and fully branded micro-learning videos that capture our organization’s spirit and celebration of sneaker and youth culture around the globe.”"
    },
    {
        name: 'Miranda Ormsby',
        position: 'Systems Integration Business Analyst',
        img: 'https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1615543883/hp2021/slider_1/slider-logo-2.png',
        content: "“My team helps with change management in our organization and we love using Powtoons to demonstrate plans, products, and even IT demonstrations. It’s the perfect way to avoid ‘Death by PowerPoint’ and keep our viewers engaged.”"
    }
]

const sliderFS = [
    {
        title: 'Company Content Hub',
        imgArr: [
            'https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1615544752/hp2021/slider_2/slide_3/company_content_hub_icon_tabs.svg',
            'https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1615551589/hp2021/slider_2/slide_3/company_content_hub_icon_folder.svg',
            'https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1615544751/hp2021/slider_2/slide_3/company_content_hub_icon_files.svg'
        ]
    },
    {
        title: 'Brand Management',
        imgArr: [
            'https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1615544618/hp2021/slider_2/slide_2/Card1.svg',
            'https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1615544586/hp2021/slider_2/slide_2/illustration1.svg']
    },
    {
        title: 'Team Collaboration',
        imgArr: [
            'https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1615544311/hp2021/slider_2/slide_1/Daniel.png',
            'https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1615544318/hp2021/slider_2/slide_1/Michael.png',
            'https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1615544311/hp2021/slider_2/slide_1/Cardlogo.svg',
            'https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1615544318/hp2021/slider_2/slide_1/Slider.svg']
    },
    {
        title: 'Enterprise Security',
        imgArr: [
            'https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1615544891/hp2021/slider_2/slide_4/enterprise_security_icon_browser.svg',
            'https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1615544892/hp2021/slider_2/slide_4/enterprise_security_icon_lock.svg',
            'https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1615544891/hp2021/slider_2/slide_4/enterprise_security_icon_iso.svg',
            'https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1615544891/hp2021/slider_2/slide_4/enterprise_security_icon_files.svg',
            'https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1615544891/hp2021/slider_2/slide_4/enterprise_security_icon_cloud1.svg',
            'https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1615544892/hp2021/slider_2/slide_4/enterprise_security_icon_password.svg',
            'https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1615544891/hp2021/slider_2/slide_4/enterprise_security_icon_cloud.svg',
            'https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1615544891/hp2021/slider_2/slide_4/enterprise_security_icon_chart.svg'
        ]
    }
]

const footer = [
    {
        name: 'Company',
        content: [
            {
                title: 'About Powtoon',
                link: '/aboutus/'
            },
            {
                title: 'Hire a Powtoonist',
                link: 'https://track.fiverr.com/visit/?bta=20984&brand=fiverrcpa&utm_campaign=Footer&landingPage=https%3A%2F%2Fwww.fiverr.com%2Fstores%2Fpowtoon-powtoonist'
            },
            {
                title: 'Careers',
                link: '/jobs/'
            },
            {
                title: 'Press Kit',
                link: 'https://press.powtoon.com/?_gl=1*1vngk61*_ga*MTEzMzY1NDExNC4xNjE3MDk3MjM0*_ga_98Q92H2JTQ*MTYxODMyMjE1NS40Ni4xLjE2MTgzMjIyNzEuMzU.'
            },
            {
                title: 'Contact Us',
                link: 'https://support.powtoon.com/en/contact?_gl=1*1u9xh8f*_ga*MTEzMzY1NDExNC4xNjE3MDk3MjM0*_ga_98Q92H2JTQ*MTYxODMyMjE1NS40Ni4xLjE2MTgzMjIyNDYuNjA.'
            }
        ]
    },
    {
        name: 'Features',
        content: [{
                title: 'Animated Videos',
                link: 'https://www.powtoon.com/create/animated-videos'
            },
            {
                title: 'Video Messaging ',
                link: 'https://www.powtoon.com/capture-screen-recorder/'
            },
            {
                title: 'Character Builder',
                link: 'https://www.powtoon.com/lp/character-builder/'
            },
            {
                title: 'PowerPoint to video',
                link: 'https://www.powtoon.com/powtoon-for-powerpoint/'
            }
        ]
    },
    {
        name: 'Solutions',
        content: [{
                title: 'Enterprise',
                link: 'https://www.powtoon.com/enterprise/'
            },
            {
                title: 'Learning & Development',
                link: 'https://www.powtoon.com/solution/learning-development'
            },
            {
                title: 'Internal Comms',
                link: 'https://www.powtoon.com/video-templates/internal-comms-make-video'
            },
            {
                title: 'Consulting',
                link: 'https://www.powtoon.com/solution/consulting'
            },
            {
                title: 'HR',
                link: 'https://www.powtoon.com/video-templates/hr-make-video'
            },
            {
                title: 'IT',
                link: 'https://www.powtoon.com/video-templates/it-make-video?parent_node=internal-comms'
            },
            {
                title: 'Education',
                link: 'https://go.powtoon.com/higher-ed/'
            },
            {
                title: 'Sales',
                link: 'https://www.powtoon.com/video-templates/sales-make-video'
            },
            {
                title: 'Marketing',
                link: 'https://www.powtoon.com/video-templates/marketing-strategy-make-video'
            },
            {
                title: 'Agencies',
                link: 'https://www.powtoon.com/agency/'
            }
        ]
    },
    {
        name: 'Learn',
        content: [{
                title: 'Blog',
                link: 'https://www.powtoon.com/blog/'
            },
            {
                title: 'Content Library',
                link: 'https://www.powtoon.com/labs/'
            },
            {
                title: 'Customer Stories',
                link: 'https://www.powtoon.com/customers/'
            },
            {
                title: 'Communication Heroes',
                link: '#'
            },
            {
                title: 'Community',
                link: '#'
            }
        ]
    },
    {
        name: 'Support',
        content: [{
                title: 'Integrations',
                link: '/integrations/'
            },
            {
                title: 'Extensions',
                link: '/powtoon-for-photoshop/'
            },
            {
                title: 'Knowledge Base',
                link: 'https://support.powtoon.com/en/'
            },
            {
                title: 'Tutorials',
                link: 'https://www.powtoon.com/labs/webinars/'
            }
        ]
    }
]

const icoArr = [
    'https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1615542700/hp2021/icons/Layout.svg',
    'https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1615542700/hp2021/icons/Mesh.svg',
    'https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1615542702/hp2021/icons/Text.svg',
    'https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1615542700/hp2021/icons/Characters.svg',
    'https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1615542700/hp2021/icons/Case_Cofee.svg',
    'https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1615542702/hp2021/icons/Shapes.svg',
    'https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1615542700/hp2021/icons/Images.svg',
    'https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1615542702/hp2021/icons/Play_window.svg',
    'https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1615542702/hp2021/icons/Note.svg',
    'https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1615542700/hp2021/icons/Focus.svg'
];
const forms = [
    'https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1615542442/hp2021/forms/1.svg',
    'https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1615542442/hp2021/forms/2.svg',
    'https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1615542442/hp2021/forms/3.svg',
    'https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1615542442/hp2021/forms/4.svg'
];
const sponsors = [
    'https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1616484392/hp2021/sponsors/Group_16764.svg',
    'https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1616484392/hp2021/sponsors/Group_11668.svg',
    'https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1616484394/hp2021/sponsors/Path_383.svg',
    'https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1616484392/hp2021/sponsors/Path_386.svg',
    'https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1616484392/hp2021/sponsors/Group_16770.svg',
    'https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1616484392/hp2021/sponsors/Group_16769.svg',
    'https://res.cloudinary.com/powtoon-dev/image/upload/f_auto,q_auto/v1616484392/hp2021/sponsors/Group_16767.svg'
];


const data = {
    cards: cards,
    employee: employee,
    slider: slider,
    sliderFS: sliderFS,
    illustrationTab: illustrationTab,
    footer: footer,
    icoArr: icoArr,
    forms: forms,
    sponsors: sponsors
}

export default data;
